var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visit-contact-redirect"},[(_vm.loading)?_c('Loader'):_c('div',{staticClass:"status-wrapper container"},[(_vm.error)?_c('div',{staticClass:"status error"},[_c('p',[_vm._v(_vm._s(_vm.error))])]):_c('div',{staticClass:"status"},[_c('p',[_vm._v("Redirigiendo al chat...")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }